import { ActionKeys } from './constants';

export function fetchShippingMethods() {
  return <const>{
    type: ActionKeys.FETCH_SHIPPING_METHODS,
  };
}

export function fetchShippingMethodsSuccess(shippingMethods: string[]) {
  return <const>{
    type: ActionKeys.FETCH_SHIPPING_METHODS_SUCCESS,
    payload: {
      shippingMethods,
    },
  };
}

export function fetchShippingMethodsError() {
  return <const>{
    type: ActionKeys.FETCH_SHIPPING_METHODS_ERROR,
  };
}

export type ShippingMethodsActions =
  | ReturnType<typeof fetchShippingMethods>
  | ReturnType<typeof fetchShippingMethodsSuccess>
  | ReturnType<typeof fetchShippingMethodsError>;
